<template>
  <div class="arrange-page page-container" v-loading="loading">
    <div class="yn-biz-header">
      <span class="yn-biz-title">检测任务安排</span>
      <div class="header-actions">
        <el-button size="mini" icon="el-icon-refresh" @click="reloadAll">刷新</el-button>
      </div>
    </div>

    <div class="ar-layout">
      <div class="ar-left">
        <div class="ar-left-hd">
          <span>待安排的任务 ({{ pending.length }})</span>
          <el-button type="text" size="mini" @click="loadPending">刷新</el-button>
        </div>
        <div class="ar-search">
          <el-input v-model="keyword" size="mini" clearable placeholder="关键字" prefix-icon="el-icon-search" />
        </div>
        <div class="ar-task-list">
          <div
            v-for="p in filteredPending"
            :key="p.xmbh"
            class="ar-task-item"
            :class="{ active: p.xmbh === xmbh }"
            @click="selectProject(p.xmbh)"
          >
            <div class="ar-task-name">{{ p.xmmc || p.xmbh }}</div>
            <div class="ar-task-meta">
              <span>{{ p.xmbh }}</span>
              <span>{{ formatDeliver(p.deliver_date || p.div_date) }}</span>
            </div>
            <div class="ar-task-sub">{{ p.item_count || 0 }} 个检测项目</div>
          </div>
          <div v-if="!listLoading && !filteredPending.length" class="ar-empty">暂无待安排任务</div>
        </div>
      </div>

      <div class="ar-right">
        <div class="ar-toolbar">
          <el-button
            type="danger"
            size="small"
            plain
            :loading="rolling"
            :disabled="!xmbh || detail.sent"
            @click="onRollback"
          >退回样品管理</el-button>
          <el-select
            v-model="batchAnalyserId"
            size="small"
            filterable
            clearable
            placeholder="批量设置分析人"
            style="width:150px;margin-left:8px"
            @change="applyBatchAnalyser"
          >
            <el-option v-for="u in analysts" :key="u.id" :label="u.xm" :value="String(u.id)" />
          </el-select>
          <el-button
            type="primary"
            size="small"
            :loading="sending"
            :disabled="!xmbh || detail.sent"
            @click="onSend"
          >提交 实验室分析</el-button>
          <span class="ar-meta">
            <span v-if="detail.xmmc">{{ detail.xmmc }}</span>
            <span v-if="detail.xmzt_label" style="margin-left:8px">状态 {{ detail.xmzt_label }}</span>
            <span class="text-danger" style="margin-left:8px">当前 {{ rows.length }} 条</span>
          </span>
        </div>

        <el-table
          ref="table"
          class="ar-table"
          :data="rows"
          size="mini"
          border
          stripe
          height="calc(100vh - 220px)"
          style="width:100%"
          @selection-change="onSelChange"
        >
          <el-table-column type="selection" width="40" :selectable="() => !detail.sent" />
          <el-table-column prop="item" label="项目" width="88" show-overflow-tooltip />
          <el-table-column label="编码/个数" min-width="160" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span>{{ codesLabel(row) }}</span>
              <span class="text-muted"> ({{ row.count || (row.codes && row.codes.length) || 0 }}个)</span>
            </template>
          </el-table-column>
          <el-table-column label="分析人" width="140">
            <template slot-scope="{ row }">
              <el-select
                v-model="row.analyser_yhid"
                size="mini"
                filterable
                clearable
                placeholder="选择"
                :disabled="detail.sent"
                style="width:100%"
                @change="(v) => onAnalyserChange(row, v)"
              >
                <el-option v-for="u in analysts" :key="u.id" :label="u.xm" :value="String(u.id)" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="报告期限" width="138">
            <template slot-scope="{ row }">
              <el-date-picker
                v-model="row.report_due"
                type="date"
                value-format="yyyy-MM-dd"
                size="mini"
                :disabled="detail.sent"
                style="width:100%"
              />
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="100">
            <template slot-scope="{ row }">
              <el-input v-model="row.remark" size="mini" :disabled="detail.sent" placeholder="" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import { isLabAnalyst } from '@/utils/user'

export default {
  name: 'ArrangeAnalyser',
  data() {
    return {
      loading: false,
      listLoading: false,
      sending: false,
      rolling: false,
      keyword: '',
      pending: [],
      xmbh: this.$route.query.xmbh || '',
      detail: {},
      rows: [],
      selectedRows: [],
      analysts: [],
      batchAnalyserId: ''
    }
  },
  computed: {
    filteredPending() {
      const k = String(this.keyword || '').trim()
      if (!k) return this.pending
      return this.pending.filter(p => {
        const blob = `${p.xmbh || ''} ${p.xmmc || ''} ${p.wtdw_mc || ''}`
        return blob.indexOf(k) >= 0
      })
    }
  },
  mounted() {
    this.loadAnalysts()
    this.reloadAll()
  },
  methods: {
    formatDeliver(d) {
      if (!d) return ''
      const s = String(d).slice(0, 10)
      const m = s.match(/^\d{4}-(\d{2})-(\d{2})$/)
      if (m) return `${parseInt(m[1], 10)}月${parseInt(m[2], 10)}日`
      return s
    },
    codesLabel(row) {
      const codes = row.codes || []
      if (!codes.length) return '—'
      if (codes.length <= 2) return codes.join('、')
      return `${codes[0]} … ${codes[codes.length - 1]}`
    },
    async reloadAll() {
      await this.loadPending()
      if (this.xmbh) await this.loadDetail()
    },
    async loadAnalysts() {
      try {
        const res = await api.get('yn_yh_list')
        const all = res.data || []
        this.analysts = all
          .filter(u => Number(u.zt) === 1 && (isLabAnalyst(u) || /分析/.test(String(u.jsmc_ls || ''))))
          .map(u => ({ id: String(u.id), xm: u.xm, dlh: u.dlh }))
      } catch (e) {
        this.analysts = []
      }
    },
    async loadPending() {
      this.listLoading = true
      try {
        const res = await api.get('yn_tr_arrange_list')
        this.pending = (res.data && res.data.items) || []
        if (this.xmbh && !this.pending.some(p => p.xmbh === this.xmbh)) {
          // 路由带 xmbh 但已安排完：仍尝试加载明细
        } else if (!this.xmbh && this.pending.length === 1) {
          this.xmbh = this.pending[0].xmbh
        }
        if (this.xmbh) await this.loadDetail()
      } catch (e) {
        this.pending = []
      } finally {
        this.listLoading = false
      }
    },
    selectProject(xmbh) {
      if (!xmbh) return
      this.xmbh = xmbh
      if (this.$route.query.xmbh !== xmbh) {
        this.$router.replace({ path: '/soil/arrange', query: { xmbh } }).catch(() => {})
      }
      this.loadDetail()
    },
    async loadDetail() {
      if (!this.xmbh) return
      this.loading = true
      try {
        const res = await api.get('yn_tr_arrange_get', { xmbh: this.xmbh })
        const data = res.data || {}
        if (data.error) {
          this.$message.error(data.error)
          this.detail = {}
          this.rows = []
          return
        }
        this.detail = data
        this.rows = (data.items || []).map(r => ({
          ...r,
          analyser_yhid: r.analyser_yhid ? String(r.analyser_yhid) : '',
          selected: r.selected !== false
        }))
        this.$nextTick(() => {
          if (this.$refs.table) {
            this.rows.forEach(r => {
              if (r.selected !== false) this.$refs.table.toggleRowSelection(r, true)
            })
          }
        })
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    onSelChange(list) {
      this.selectedRows = list || []
    },
    onAnalyserChange(row, yhid) {
      const u = this.analysts.find(a => String(a.id) === String(yhid))
      row.analyser_xm = (u && u.xm) || ''
    },
    applyBatchAnalyser(yhid) {
      if (!yhid) return
      const u = this.analysts.find(a => String(a.id) === String(yhid))
      const target = this.selectedRows.length ? this.selectedRows : this.rows
      target.forEach(r => {
        r.analyser_yhid = String(yhid)
        r.analyser_xm = (u && u.xm) || ''
      })
      this.batchAnalyserId = ''
      this.$message.success('已批量设置分析人')
    },
    buildPayload() {
      const selSet = {}
      this.selectedRows.forEach(r => { selSet[r.key] = 1 })
      const hasSel = this.selectedRows.length > 0
      const items = this.rows.map(r => ({
        key: r.key,
        item: r.item,
        codes: r.codes || [],
        count: r.count || (r.codes && r.codes.length) || 0,
        analyser_yhid: r.analyser_yhid || '',
        analyser_xm: r.analyser_xm || '',
        report_due: r.report_due || '',
        remark: r.remark || '',
        selected: hasSel ? !!selSet[r.key] : true
      }))
      return {
        xmbh: this.xmbh,
        items,
        lab_receiver_yhid: '',
        lab_receiver_xm: ''
      }
    },
    async onSend() {
      if (!this.xmbh) return
      const payload = this.buildPayload()
      const toSend = payload.items.filter(i => i.selected !== false)
      if (!toSend.length) {
        this.$message.warning('请勾选需要提交的项目')
        return
      }
      const miss = toSend.find(i => !i.analyser_yhid)
      if (miss) {
        this.$message.warning('请安排「' + miss.item + '」的分析人员')
        return
      }
      try {
        await this.$confirm(
          `确认提交实验室分析？共 ${toSend.length} 项`,
          '提交确认',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      this.sending = true
      try {
        const res = await api.postJson('yn_tr_arrange_send', this.buildPayload())
        const data = res.data || {}
        if (data.error) {
          this.$message.error(data.error)
          return
        }
        this.$message.success('已提交实验室分析')
        this.xmbh = ''
        this.detail = {}
        this.rows = []
        await this.loadPending()
      } catch (e) {
        this.$message.error('提交失败')
      } finally {
        this.sending = false
      }
    },
    async onRollback() {
      if (!this.xmbh) return
      let reason = ''
      try {
        const { value } = await this.$prompt('必须填写回退原因', '退回样品管理', {
          confirmButtonText: '确认退回',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputPlaceholder: '请说明退回原因…',
          inputValidator: (v) => {
            if (!v || !String(v).trim()) return '必须填写回退原因'
            return true
          }
        })
        reason = String(value || '').trim()
      } catch (e) {
        return
      }
      this.rolling = true
      try {
        const res = await api.postJson('yn_tr_arrange_rollback', { xmbh: this.xmbh, reason })
        const data = res.data || {}
        if (data.error) {
          this.$message.error(data.error)
          return
        }
        this.$message.success(data.message || '已退回样品管理')
        this.xmbh = ''
        this.detail = {}
        this.rows = []
        await this.loadPending()
      } catch (e) {
        this.$message.error('退回失败')
      } finally {
        this.rolling = false
      }
    }
  }
}
</script>

<style scoped>
.ar-layout {
  display: flex;
  gap: 0;
  border: 1px solid #e4e7ed;
  background: #fff;
  min-height: calc(100vh - 140px);
}
.ar-left {
  width: 280px;
  border-right: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.ar-left-hd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #e4e7ed;
  font-weight: 600;
}
.ar-search { padding: 8px 12px; border-bottom: 1px solid #e4e7ed; }
.ar-task-list { flex: 1; overflow: auto; }
.ar-task-item {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f2f5;
  cursor: pointer;
}
.ar-task-item:hover { background: #f5f7fa; }
.ar-task-item.active { background: #ecf5ff; }
.ar-task-name { font-weight: 600; font-size: 13px; color: #303133; }
.ar-task-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}
.ar-task-sub { margin-top: 2px; font-size: 12px; color: #f56c6c; }
.ar-empty { color: #909399; font-size: 12px; padding: 24px; text-align: center; }
.ar-right { flex: 1; min-width: 0; display: flex; flex-direction: column; overflow: hidden; }
.ar-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-bottom: 1px solid #e4e7ed;
  background: #f5f7fa;
}
.ar-meta { font-size: 12px; color: #606266; margin-left: 8px; }
.ar-table {
  width: 100%;
}
.ar-table >>> .el-table__body-wrapper {
  overflow-x: hidden;
}
.ar-table >>> .el-table__header-wrapper {
  overflow-x: hidden;
}
.text-danger { color: #f56c6c; }
.text-muted { color: #909399; }
</style>
